import React from 'react'

const Icon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path  fillOpacity=".65" d="M11.092 10.003L6.847 5.015c-.117-.137-.181-.32-.181-.516 0-.195.064-.379.181-.516l.372-.437c.117-.137.273-.213.44-.213.165 0 .321.076.438.213l5.055 5.94c.117.137.181.32.18.516.001.197-.063.38-.18.518l-5.05 5.933c-.117.138-.273.214-.44.214-.165 0-.321-.076-.438-.214l-.372-.436c-.242-.285-.242-.748 0-1.032l4.24-4.982z"/>
  </svg>
)

export default Icon
